export const VIEW_CHANGE_DELAY = 500 // in ms
export const MAX_ACTIVITY_NUMBER = 20
export const MIN_ACTIVITY_NUMBER = 1
export const MAX_KUDOS = 3
export const MAX_STREAK = 3
const CLICK_TIMEOUT_BUFFER = 1000
export const CHECK_ANS_BUTTON_CLICK_TIMEOUT = VIEW_CHANGE_DELAY + CLICK_TIMEOUT_BUFFER
export const ONE_COLUMN_LAYOUT = 'one-column'
export const TWO_COLUMN_LAYOUT = 'two-column'
